import React from "react";

import styles from "./styles/Dashboard.module.scss";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { useSelector } from "react-redux";
import TrainingCategories from "../Components/TrainingCategories";

export default function Categories({ setPage }) {
  
  var dashboardData = useSelector((state) => state.dashboard.allCategories);


  return (
    <div className={styles.Dashboard}>
      <TrainingCategories data={dashboardData} />
    </div>
  );
}
